/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Collapse } from 'reactstrap';

import BaseGrid from '../Common/BaseGrid';

import { del, post } from '../../helpers/api_helper';
import ItemSelector from './ItemSelector';

function Substitutes(props) {
  // eslint-disable-next-line no-unused-vars
  const { t, item } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [refresh, setRefresh] = React.useState(0);
  const [adder, setAdder] = React.useState(false);
  const [selectorKey, setSelectorKey] = React.useState(0);

  const unrelate = async (itm) => {
    try {
      if (confirm(`Are you sure you want to unrelate ${itm.item_id}?`)) {
        await del(`/api/items/substitutes/${itm.id}`);

        setRefresh(refresh + 1);
      }
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const addRelation = async () => {
    setSelectorKey((key) => key + 1);
    setAdder(true);
  };

  const relate = async (itm) => {
    try {
      await post('/api/items/substitutes/associate', { items: [item, itm] });

      setAdder(false);
      setRefresh(refresh + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  useEffect(() => {
    setRefresh(refresh + 1);
  }, [item]);

  const jsx = (
    <div>
      {item && item.id && (
        <>
          <Collapse isOpen={adder}>
            <ItemSelector
              key={selectorKey}
              openByDefault
              onSelect={relate}
            />
          </Collapse>

          {!adder && (
          <BaseGrid
            url={`/api/items/substitutes/${item.id}`}
            shouldUpdate={refresh}
            className="table table-sm fs-6 table-nowrap table-hover table-bordered"
            create={addRelation}
            config={
            {
              columns: {
                thumb: {
                  label: '',
                  image: {
                    src: (itm) => (`/api/items/thumbnail/${itm.item_id}`),
                    class: 'rounded',
                    style: { maxHeight: '3rem', maxWidth: '3rem' },
                  },
                  translate: false,
                },
                id: {
                  label: props.t('ID'),
                  format: (f, itm) => itm.item_id,
                  link: {
                    to: '/item/%item_id%',
                  },
                },
                manufacturer: {
                  label: props.t('Manufacturer'),
                  format: (f, itm) => (itm.item ? itm.item.manufacturer : 'N/A'),
                },
                part_number: {
                  label: props.t('Part Number'),
                  link: {
                    to: '/item/%item_id%',
                  },
                  format: (f, itm) => (itm && itm.item ? itm.item.part_number : 'N/A'),
                },
                qty: {
                  label: props.t('Qty'),
                  format: (f, itm) => itm.item.qty || 0,
                },
                condition: {
                  label: props.t('Condition'),
                  sort: true,
                  format: (f, itm) => (itm.item ? itm.item.condition : 'N/A'),
                },
                actions: {
                  label: '',
                  actions: [
                    {
                      key: 'delete',
                      icon: 'mdi mdi-close-thick',
                      class: 'btn btn-sm btn-soft-danger',
                      alt: props.t('Unrelate'),
                      click: unrelate,
                    },
                  ],
                },
              },
              pagination: {
                sort: 'id',
                direction: 'desc',
                perPage: 30,
              },
            }
            }
          />
          )}
        </>
      )}
    </div>
  );

  return jsx;
}

Substitutes.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(Substitutes));
